package com.platforma.chat_domain

import com.platforma.chat_domain.use_case.DraftTableUseCase

data class DraftUseCase(
    val table: DraftTableUseCase
)
